import { Stack } from '@mui/material';

import FooterBackground from 'targets/web/assets/images/tournament/tournament-footer.png';

export const TournamentCardFooter = () => (
    <Stack sx={{ mt: 8 }}>
      <Stack
        sx={{
          px: 10,
          height: '500px',
          background: `url(${FooterBackground})`,
          backgroundSize: 'cover',
          borderBottomLeftRadius: 8,
          borderBottomRightRadius: 8,
          justifyContent: 'center',
          alignItems: 'center',
        }}></Stack>
    </Stack>
  );
